import { type CmsContentBlockData } from "@chewy/cms-content-block";
import { type CmsSkuData } from "@chewy/cms-sku";
import { useEffect } from "react";

import { type CmsComponentData } from "../components/cms-component";

const WISTIA_SCRIPT_URL = "//fast.wistia.net/assets/external/E-v1.js";

function isWistiaLoaded() {
  return (
    typeof document !== "undefined" &&
    Array.from(document.scripts).some((script) => script.src.includes(WISTIA_SCRIPT_URL))
  );
}

function isMediaBlock(data: CmsComponentData): boolean {
  if (data.type === "STANDARD-CONTENT-BLOCK") {
    return (data as CmsContentBlockData).items?.some((item) => item?.itemType === "media");
  }
  if (data.type === "STANDARD-SKU") {
    return Boolean((data as CmsSkuData).contextCardConfig?.video);
  }
  return false;
}

export default function useWistiaScript(components?: CmsComponentData[]) {
  const requiresWistiaScript = Boolean(components?.some(isMediaBlock));

  useEffect(() => {
    if (!requiresWistiaScript) {
      return;
    }
    if (!isWistiaLoaded()) {
      console.log(`Video content found. Injecting wistia script: ${WISTIA_SCRIPT_URL}`);
      const src = `https:${WISTIA_SCRIPT_URL}`;
      const s = document.createElement("script");
      s.src = src;
      s.async = true;
      const head = document.getElementsByTagName("head")[0];
      head?.appendChild(s);
    }
  }, [requiresWistiaScript]);
}
